










import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../lib/ajax';
import AbpBase from '../../../../../lib/abpbase';
import QuickTable from "../../../../../components/table/table.vue";
import Tools from '../../../../../lib/tools';
@Component({
	name:'safetyWorkDisclose',
	components: {
		QuickTable
	}
})
export default class SafetyWorkDisclose extends AbpBase {
	initData:any = {
		columns: [
			{
				title: '序号',
				type: 'index',
				width: 60
			},
			{
				title: '项目名称',
				key: 'projectName',
				render: (h:any, params:any) => {
					return h('a', {
						on: {
							click: () => {
								// 跳转至项目详情
							}
						}
					}, params.row.projectName);
				}
			},
			{
				title: '交底人',
				key: 'clarificationUser',
				render: (h:any, params:any) => {
					return h('span', params.row.clarificationUser ? params.row.clarificationUser.name : '');
				}
			},
			{
				title: '交底时间',
				key: 'clarificationDt',
				render: (h:any, params:any) => {
					return h('span', Tools.formatDate(params.row.clarificationDt));
				}
			},
			{
				title: '交底地点',
				key: 'clarificationAddress'
			},
			{
				title: '参加人员',
				key: 'clarificationMembers'
			}
		]
	}
}
